.searchField {
  display: none;
}

.searchField input:placeholder-shown {
  text-overflow: ellipsis;
}

@media all and (width > 1076px) {
  .searchField {
    display: flex;
    justify-content: flex-end;
  }
}

.container {
  position: absolute;
  inset: 0 auto auto 0;
  margin-top: var(--header-height);
  width: 360px;
  max-height: 664px;
  overflow: auto;
  background-color: var(--colors-grays-white);
  border-radius: 24px;
  box-shadow:
    0px 2px 16px 0px rgb(0 0 0 / 5%),
    0px 0px 0px 1px rgb(0 0 0 / 5%);
  z-index: var(--z-search-suggestions);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.5s ease;
}

.container::-webkit-scrollbar {
  display: none;
}

.container--open {
  opacity: 1;
  pointer-events: all;
}
